import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { categories } from "@/mocks/categories";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFound() {
  const location = useLocation();

  usePageMeta(
    "页面不存在 - 色色视频",
    "你访问的页面不存在或已调整，可以返回首页浏览电影、短片与热门视频内容。",
    "色色视频,页面不存在,404",
  );

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />

      <main className="flex flex-1 items-center py-14 md:py-20">
        <div className="container-page">
          <div className="mx-auto max-w-xl text-center">
            <p className="font-label text-[11px] font-semibold uppercase tracking-[0.24em] text-secondary-600">
              Error 404
            </p>
            <h1 className="mt-3 text-3xl font-semibold text-foreground-950 md:text-4xl">
              页面不存在
            </h1>
            <p className="mt-3 text-xs leading-relaxed text-foreground-500 md:text-sm">
              你访问的页面可能已被调整或链接输入有误。路径：
              <span className="ml-1 font-mono text-[11px] text-foreground-700">{location.pathname}</span>
            </p>

            <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
              <Link
                to="/"
                className="focus-ring inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-xs font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-home-5-line text-sm" aria-hidden="true" />
                返回首页
              </Link>
              <Link
                to="/search"
                className="focus-ring inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300/80 bg-white px-4 py-2 text-xs font-medium text-foreground-700 transition-colors hover:border-secondary-300"
              >
                <i className="ri-search-line text-sm" aria-hidden="true" />
                站内搜索
              </Link>
            </div>

            <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
              {categories.map((item) => (
                <Link
                  key={item.key}
                  to={`/category/${item.key}`}
                  className="focus-ring inline-flex items-center gap-1.5 rounded-full border border-background-300/80 bg-white px-3 py-1.5 text-[11px] text-foreground-600 transition-colors hover:border-secondary-300 hover:text-secondary-700"
                >
                  <i className={`${item.icon} text-sm`} aria-hidden="true" />
                  {item.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}